<template>
    <span v-if="i18NPicId || i18NDescription">
    <b-icon-info-circle :id="$id('picTooltip')" class="custIcon"/>
    <b-tooltip :target="$id('picTooltip')" placement="right">
<!--        {{picTitle}}-->
        <b-card class="custBody"
                :img-src="getI18NImgSrc"
                :title="picTitle"
                bg-variant="dark"
                style="width: 250px; margin-top: 5px">
            <b-card-text>
                {{i18NDescription}}
            </b-card-text>
        </b-card>

    </b-tooltip>
    </span>
</template>

<script>
    import url from "@/rest/url";

    export default {
        name: "I18NImage",
        props: ['picTitle', 'i18NPicId', 'i18NDescription'],
        computed: {
            getI18NImgSrc() {
                if (this.i18NPicId) {
                    return url.apiLocation + "/pictures/i18n/" + this.i18NPicId;
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style>
    .custIcon {
        margin-left: 6px;
        color: #6c757d;
    }

    .custBody > .card-body {
        padding: 10px;
    }
    .custBody > .card-body > h4 {
        font-size: 1.25rem;
    }
    .tooltip-inner {
    background-color: #313940 !important;
    max-width: 400px;
    /*opacity: 0.5;*/
    }

</style>